import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LatLngTuple } from 'leaflet';

import { RootState } from '../../store';
import { HydratedLocationStoryPoint, HydratedStoryPoint } from 'magical-trails';

export interface DirectionsParams {
  pointId: string;
  type: string;
}

function isLocation(
  locationPoint: HydratedStoryPoint
): locationPoint is HydratedLocationStoryPoint {
  return locationPoint.type === 'location';
}

const Directions: React.FC = () => {
  let { pointId } = useParams<DirectionsParams>();
  const [latlng, setLatlng] = useState<LatLngTuple | null>(null);
  const { currentStory } = useSelector((state: RootState) => state.trail);
  useEffect(() => {
    if (
      pointId &&
      currentStory?.storyPoints &&
      currentStory?.storyPoints.length > 0
    ) {
      const locationPoint = currentStory?.storyPoints.find(
        ({ code }) => code === pointId
      );

      if (locationPoint && isLocation(locationPoint))
        setLatlng(locationPoint?.latlng || null);
    }
  }, [pointId, currentStory?.storyPoints]);

  return (
    <div className="Directions">
      <div className="border-mt-border-soft bg-mt-surface border-b px-4 py-5 sm:px-6">
        <h3 className="text-mt-ink text-base leading-6 font-semibold">
          Directions
        </h3>
        <p className="text-mt-ink-muted mt-1 text-sm">
          {latlng?.[0]},{latlng?.[1]}
        </p>
      </div>
      {latlng && (
        <ul role="list" className="-mx-2 space-y-1">
          <li>
            <a
              href={`https://maps.google.com/?q=${latlng[0]},${latlng[1]}`}
              target="_blank"
              className="group text-mt-ink-soft hover:bg-mt-surface-2 hover:text-mt-primary flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
              rel="noopener noreferrer"
            >
              Open in Google Maps
            </a>
          </li>
          <li>
            <a
              href={`http://maps.apple.com/?ll=${latlng[0]},${latlng[1]}`}
              target="_blank"
              className="group text-mt-ink-soft hover:bg-mt-surface-2 hover:text-mt-primary flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
              rel="noopener noreferrer"
            >
              Open in Apple Maps
            </a>
          </li>
          <li>
            <a
              href={`https://bing.com/maps/default.aspx?cp=${latlng[0]},${latlng[1]}&lvl=20`}
              target="_blank"
              className="group text-mt-ink-soft hover:bg-mt-surface-2 hover:text-mt-primary flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
              rel="noopener noreferrer"
            >
              Open in Bing Maps
            </a>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Directions;
